import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=16049cdc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16049cdc')) {
      api.createRecord('16049cdc', component.options)
    } else {
      api.reload('16049cdc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=16049cdc&", function () {
      api.rerender('16049cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MNuX5tdLd1tY/JS/offershelp.vue"
export default component.exports